module.exports = __webpack_public_path__ + "static/media/Logo.7e5997f4.png";